import script from "./LoginApp.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginApp.vue?vue&type=script&setup=true&lang=js"

import "./LoginApp.vue?vue&type=style&index=0&id=8c04fbae&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c04fbae"]])

export default __exports__